// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReactController from "./react_controller"
application.register("react", ReactController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SlideoverController from "./slideover_controller"
application.register("slideover", SlideoverController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PinInputController from "./pin_input_controller"
application.register("pin-input", PinInputController)

import CanvasEditorController from "./canvas_editor_controller"
application.register("canvas-editor", CanvasEditorController)

import CanvasSortableController from "./canvas_sortable_controller"
application.register("canvas-sortable", CanvasSortableController)

import CanvasCardController from "./canvas_card_controller"
application.register("canvas-card", CanvasCardController)

import HypothesisKanbanController from "./hypothesis_kanban_controller"
application.register("hypothesis-kanban", HypothesisKanbanController)

import HypothesisCardController from "./hypothesis_card_controller"
application.register("hypothesis-card", HypothesisCardController)

import AutoCloseModalController from "./auto_close_modal_controller"
application.register("auto-close-modal", AutoCloseModalController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import EditingIndicatorController from "./editing_indicator_controller"
application.register("editing-indicator", EditingIndicatorController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import DocumentFiltersController from "./document_filters_controller"
application.register("document-filters", DocumentFiltersController)

import DocumentFormController from "./document_form_controller"
application.register("document-form", DocumentFormController)

import SyntaxHighlightController from "./syntax_highlight_controller"
application.register("syntax-highlight", SyntaxHighlightController)

import RoadmapSortableController from "./roadmap_sortable_controller"
application.register("roadmap-sortable", RoadmapSortableController)

import TaskKanbanController from "./task_kanban_controller"
application.register("task-kanban", TaskKanbanController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import RoadmapItemController from "./roadmap_item_controller"
application.register("roadmap-item", RoadmapItemController)

import TaskCardController from "./task_card_controller"
application.register("task-card", TaskCardController)

import WaitListEntryRowController from "./wait_list_entry_row_controller"
application.register("wait-list-entry-row", WaitListEntryRowController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import FoundrySceneController from "./foundry_scene_controller"
application.register("foundry-scene", FoundrySceneController)

import PersonaListController from "./persona_list_controller"
application.register("persona-list", PersonaListController)

import JourneyMapSortableController from "./journey_map_sortable_controller"
application.register("journey-map-sortable", JourneyMapSortableController)

import JourneyMapCardController from "./journey_map_card_controller"
application.register("journey-map-card", JourneyMapCardController)

import JourneyMapZoomController from "./journey_map_zoom_controller"
application.register("journey-map-zoom", JourneyMapZoomController)

import JourneyMapMetricCardController from "./journey_map_metric_card_controller"
application.register("journey-map-metric-card", JourneyMapMetricCardController)

import AvatarPickerController from "./avatar_picker_controller"
application.register("avatar-picker", AvatarPickerController)

import McpPresenceTimeoutController from "./mcp_presence_timeout_controller"
application.register("mcp-presence-timeout", McpPresenceTimeoutController)

import CanvasWizardController from "./canvas_wizard_controller"
application.register("canvas-wizard", CanvasWizardController)

import OnboardingTourController from "./onboarding_tour_controller"
application.register("onboarding-tour", OnboardingTourController)

import FeatureTourController from "./feature_tour_controller"
application.register("feature-tour", FeatureTourController)

import ConfirmDeleteController from "./confirm_delete_controller"
application.register("confirm-delete", ConfirmDeleteController)

import LexyEditorController from "./lexxy_editor_controller"
application.register("lexxy-editor", LexyEditorController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)